'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = months;

var _formatter = require('./formatter');

var _formatter2 = _interopRequireDefault(_formatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formats = {
  short: 'MMM',
  long: 'MMMM'
};

function months(locales) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'long';

  var months = [];
  while (months.length !== 12) {
    months.push((0, _formatter2.default)(new Date(2000, months.length), formats[type], locales));
  }
  return months;
}
//# sourceMappingURL=months.js.map